import gte from "ramda/src/gte";
import multiply from "ramda/src/multiply";

const exteriorUsageRanges = new Map([
  [0, 0],
  [25, 2],
  [50, 4],
  [75, 6],
  [125, 10],
  [150, 12],
  [175, 14],
  [250, 20],
  [300, 24],
  [375, 30],
  [500, 40],
  [625, 50],
  [750, 60],
  [875, 70],
  [1000, 80],
]);

const interiorUsageRanges = new Map([
  [0, 0],
  [6.25, 0.5],
  [12.5, 1],
  [25, 2],
  [50, 4],
  [62, 5],
  [75, 6],
  [125, 10],
  [150, 12],
  [175, 14],
  [250, 20],
  [300, 24],
  [375, 30],
  [500, 40],
  [625, 50],
  [750, 60],
  [875, 70],
  [1000, 80],
]);

const exteriorUsageBounds = Array.from(exteriorUsageRanges.keys());
const interiorUsageBounds = Array.from(interiorUsageRanges.keys());

const usageGreaterThanTotalAreaPredicate = (totalArea) => {
  return (usage) => gte(usage, totalArea);
};

export const findRecommendedQuantityForExteriorArea = (totalArea) => {
  const usageRangeKey = exteriorUsageBounds.find(
    usageGreaterThanTotalAreaPredicate(totalArea)
  );
  return exteriorUsageRanges.get(usageRangeKey);
};

export const findRecommendedQuantityForInteriorArea = (totalArea) => {
  const usageRangeKey = interiorUsageBounds.find(
    usageGreaterThanTotalAreaPredicate(totalArea)
  );
  return interiorUsageRanges.get(usageRangeKey);
};

export const applyTopCoatMultiplier = (totalArea) => {
  return multiply(2, totalArea);
};
